export default __webpack_public_path__ + "static/media/Veg_dot_Icon.d1a3902d.svg";